import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';
import { BiTipoPainel } from 'pages/bi/types';

export function BiTipoPainelAutoComplete({
    sx,
    name,
    value,
    error,
    size,
    queryKey,
    multiple = false,
    disabled = false,
    onChange = () => {},
    label = 'Tipo de painel',
}: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            objectId="idTipoPainelBi"
            optionStringTemplate="{dsTipoPainelBi}"
            selectedStringTemplate="{dsTipoPainelBi}"
            sx={sx}
            size={size}
            name={name}
            label={label}
            value={value}
            error={error}
            queryKey={queryKey}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            isOptionEqualToValue={(option: BiTipoPainel, value: BiTipoPainel) => option.idTipoPainelBi === value.idTipoPainelBi}
            requestOptions={{
                url: '/config/tipopainelbi',
                sort: [{ property: 'idTipoPainelBi', direction: 'ASC' }],
                nested: true,
            }}
        />
    );
}
